
import { l, tryGetTokenOverride, selectLanguage } from "./localization.js";


// Contains app-specific translations
export const buttons = {


    
    themeView(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "themeView");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de"]);

        switch (language) {
            case "en": return "View in #ICON#";
            case "de": return "Betrachten in #ICON#";
            default: return `[themeView: ${language} missing]`;
        }
    
    },
            
};
